import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { style } from '../../utils/style.js';
const imageAlignmentMap = {
    start: '@xl:self-start',
    center: '@xl:self-center',
    end: '@xl:self-end',
};
export const renderImageContainer = (image, { className, imageAlign }) => image ? (_jsx("div", { className: style('shrink-1/2 justify-self-center', imageAlign && imageAlignmentMap[imageAlign], className), children: image })) : null;
//# sourceMappingURL=renderImageContainer.js.map